import React from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import EditView from 'bstrap-react-mobx-admin/view/edit'
import I18nInput from '../input/i18n'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import { Button } from 'react-bootstrap'
import { Helmet } from 'react-helmet'

const ArtistEditForm = ({ store }) => {
  const entity = store.cv.record
  const errors = store.cv.errors
  const updateField = store.cv.updateData.bind(store.cv)
  const disabled = !store.hasRight(defaultConst.ENTNAMES.PERSONS, 'w')
  const name = entity && entity.has('name') && entity.get('name') && entity.get('name')[0]
  const tablang = store.langtab ||
    (store.router && store.router.queryParams && store.router.queryParams._langtab)
  const tablangName = tablang && entity.has('name') && entity.get('name').find(i => i.lang === tablang)

  return (
    <div className='row'>
      <Helmet title={store.__(linkConst.LINK_PERSONS_TITLE).concat(defaultConst.HTML_DIVIDER) + (entity.has('id')
        ? ((name && name.value) || store.__(defaultConst.TITLE_EDIT))
        : store.__(defaultConst.TITLE_CREATE))} />
      <div className='col-xs-12 col-sm-9 col-md-6'>
        {tablang && tablang !== defaultConst.DEFAULT_LANG && (!tablangName || !tablangName.value) &&
          <p>
            <Button bsSize='small' bsStyle='info' onClick={() => store.cv.copyLang(entity, tablang)}>
              <i className='glyphicon glyphicon-duplicate' />&nbsp;
              {store.__('Copy the ') + defaultConst.DEFAULT_LANG.toUpperCase() + store.__(' name into ') + tablang.toUpperCase()}
            </Button>
          </p>
        }
        <I18nInput
          attrs={entity.get('name')}
          disabled={disabled}
          errors={errors}
          label={store.__('name')}
          name='name'
          onAdd={store.cv.handleAdd}
          onChange={store.cv.handleChange}
          onRemove={store.cv.handleRemove}
          optionsMap={store.options}
          store={store}
          tablang={tablang} />
        <TextInput type='number' step='1'
          label={store.__('birth year')}
          attr={'birth_year'}
          record={entity}
          onChange={updateField}
          errors={errors} disabled={disabled} />
      </div>
    </div>
  )
}

ArtistEditForm.propTypes = {
  store: PropTypes.object.isRequired
}

const ArtistEditView = ({ store }) => {
  //
  if (!store.hasRight(defaultConst.ENTNAMES.PERSONS)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  return (
    <EditView store={store.cv} onReturn2list={store.onReturn2list.bind(store)}
      enabled={store.hasRight(defaultConst.ENTNAMES.PERSONS, 'w')} >
      <ArtistEditForm store={store} />
    </EditView>
  )
}
export default observer(ArtistEditView)
